import dayjs from "dayjs";
import { isEmpty, isUndefined } from "lodash";
import { IFormStatePrograma, TipoAnexo, IPropsAnexo, IFormStateEntidades } from "../servicos/IFormularios.ts";

/* A11yProps */
export function a11yProps(index: number)
{
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

/* Validação de data */
export const isValidDate = (value) => {
    if (value) {
        const date = dayjs(value);
        const minYear = 1900;
        const maxYear = 2150;
        return date.isValid() && (date.year() <= maxYear && date.year() >= minYear) && date.year().toString().length === 4;
    }else{
        return true;
    }
};

// Função auxiliar para simular um FileList
export const createSimulatedFileList = (file: File) => {
    return {
        0: file,
        length: 1,
        item: (index: number) => (index === 0 ? file : null), // Retorna o arquivo corretamente
    };
}

/* Transformação de data */
export const transformarData = (data: IFormStatePrograma) => {
    
    const tipos = {
        programaAnexos: TipoAnexo.ANEXO,
        serieAnexos: TipoAnexo.ANEXO,
        autorizacoes: TipoAnexo.AUTORIZACAO,
        planilhasMusicais: TipoAnexo.PLANILHA_MUSICAL,
        materiaisDivulgacao: TipoAnexo.MATERIAL_DIVULGACAO,
        recursosAcessibilidade: TipoAnexo.RECURSO_ACESSIBILIDADE,
        anexosOutros: TipoAnexo.OUTRO,
    };

    let programaAnexos:IPropsAnexo[] = [];

    // Iteramos sobre cada chave do objeto `tipos`
    Object.keys(tipos).forEach((chave) => {
        if (Array.isArray(data[chave])) {
            const anexosComTipo = data[chave].map((item) => ({
                ...item,
                tipo: tipos[chave], // Adiciona o tipo correto ao item
            }));
            programaAnexos.push(...anexosComTipo); // Junta os elementos ao array final
        }
    });

    return programaAnexos;
};

export const filterSeriesOptions = (options: any[], { inputValue }: any) => {
    // Defina o número mínimo de caracteres exigidos
    const minChars = 2;
    if (inputValue.length < minChars) {
        // Retorna um array vazio para ocultar as opções quando o número mínimo de caracteres não for atingido
        return [];
    }
    // Filtra as opções com base no texto digitado
    return options.filter((option) =>
        option?.titulo?.toLowerCase().includes(inputValue.toLowerCase())
    );
};

export const prepararProgramaFormData = (programa: IFormStatePrograma, form: FormData) => 
{
    programa.classificacaoEtaria = (programa.classificacaoEtaria === "" || isUndefined(programa.classificacaoEtaria)) ? null : programa.classificacaoEtaria;
    programa.idiomaVersao = (programa.idiomaVersao === "" || isUndefined(programa.idiomaVersao)) ? null : programa.idiomaVersao;
    programa.licenciamento = (programa.licenciamento === "" || isUndefined(programa.licenciamento)) ? null : programa.licenciamento;
    programa.tipoPrograma = (programa.tipoPrograma === "" || isUndefined(programa.tipoPrograma)) ? null : programa.tipoPrograma;
    programa.tipoMidia = (programa.tipoMidia === "" || isUndefined(programa.tipoMidia)) ? null : programa.tipoMidia;
    programa.versao = (programa.versao === "" || isUndefined(programa.versao)) ? null : programa.versao;
    programa.vigencia = (programa.vigencia === "" || isUndefined(programa.vigencia)) ? null : programa.vigencia;
    programa.duracao = (programa.duracao === "" || isUndefined(programa.duracao)) ? null : programa.duracao;

    if(programa.programaTimecodes && programa.programaTimecodes.length > 0)
        programa.programaTimecodes.map((DataHora,keyDataHora) =>
        {
            programa.programaTimecodes[keyDataHora].dataHora = new Date(DataHora.dataHora).toISOString()
        });

    form.append('programa', JSON.stringify(programa));

    for (let i = programa.programaAnexos?.length - 1; i >= 0; i--)
    {
        const anexo = programa.programaAnexos[i];
        // anexo.tipo = 'anexo';
        if ((anexo.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`anexo.${i}.arquivo`, anexo.arquivo[0]);
        } else if (isEmpty(anexo.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.programaAnexos.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = programa.autorizacoes?.length - 1; i >= 0; i--)
    {
        const autorizacao = programa.autorizacoes[i];
        // anexo.tipo = 'anexo';
            if ((autorizacao.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`autorizacao.${i}.arquivo`, autorizacao.arquivo[0]);
        } else if (isEmpty(autorizacao.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.autorizacoes.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = programa.planilhasMusicais?.length - 1; i >= 0; i--)
    {
        const planilhasMusicais = programa.planilhasMusicais[i];
        // anexo.tipo = 'anexo';
            if ((planilhasMusicais.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`planilhasMusicais.${i}.arquivo`, planilhasMusicais.arquivo[0]);
        } else if (isEmpty(planilhasMusicais.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.planilhasMusicais.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = programa.materiaisDivulgacao?.length - 1; i >= 0; i--)
    {
        const materiaisDivulgacao = programa.materiaisDivulgacao[i];
        // anexo.tipo = 'anexo';
            if ((materiaisDivulgacao.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`materiaisDivulgacao.${i}.arquivo`, materiaisDivulgacao.arquivo[0]);
        } else if (isEmpty(materiaisDivulgacao.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.materiaisDivulgacao.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = programa.recursosAcessibilidade?.length - 1; i >= 0; i--)
    {
        const recursosAcessibilidade = programa.recursosAcessibilidade[i];
        // anexo.tipo = 'anexo';
            if ((recursosAcessibilidade.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`recursosAcessibilidade.${i}.arquivo`, recursosAcessibilidade.arquivo[0]);
        } else if (isEmpty(recursosAcessibilidade.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.recursosAcessibilidade.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = programa.anexosOutros?.length - 1; i >= 0; i--)
    {
        const anexosOutros = programa.anexosOutros[i];
        // anexo.tipo = 'anexo';
            if ((anexosOutros.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`anexosOutros.${i}.arquivo`, anexosOutros.arquivo[0]);
        } else if (isEmpty(anexosOutros.nome)) {
            // Linha nova mas sem arquivo selecionado
            programa.anexosOutros.splice(i, 1); // Remove o item do array
        }
    }
};

export const prepararSerieFormData = (serie: IFormStateEntidades, form: FormData) => 
{
    // Ajusta os campos que podem ser null ou undefined
    serie.classificacaoEtaria = (serie.classificacaoEtaria === "" || isUndefined(serie.classificacaoEtaria)) ? null : serie.classificacaoEtaria;
    serie.tipoSerie = (serie.tipoSerie === "" || isUndefined(serie.tipoSerie)) ? null : serie.tipoSerie;
    
    // Adiciona a série como JSON no FormData
    form.append('serie', JSON.stringify(serie));
    
    // Trata os anexos (serieAnexos)
    for (let i = serie.serieAnexos?.length - 1; i >= 0; i--)
    {
        const anexo = serie.serieAnexos[i];
    
        if ((anexo.arquivo as unknown as FileList)?.length > 0)
        {
            form.append(`anexo.${i}.arquivo`, anexo.arquivo[0]);
        }
        else if (isEmpty(anexo.nome))
        {
            serie.serieAnexos.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = serie.autorizacoes?.length - 1; i >= 0; i--)
    {
        const autorizacao = serie.autorizacoes[i];
        // anexo.tipo = 'anexo';
            if ((autorizacao.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`autorizacao.${i}.arquivo`, autorizacao.arquivo[0]);
        } else if (isEmpty(autorizacao.nome)) {
            // Linha nova mas sem arquivo selecionado
            serie.autorizacoes.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = serie.planilhasMusicais?.length - 1; i >= 0; i--)
    {
        const planilhasMusicais = serie.planilhasMusicais[i];
        // anexo.tipo = 'anexo';
            if ((planilhasMusicais.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`planilhasMusicais.${i}.arquivo`, planilhasMusicais.arquivo[0]);
        } else if (isEmpty(planilhasMusicais.nome)) {
            // Linha nova mas sem arquivo selecionado
            serie.planilhasMusicais.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = serie.materiaisDivulgacao?.length - 1; i >= 0; i--)
    {
        const materiaisDivulgacao = serie.materiaisDivulgacao[i];
        // anexo.tipo = 'anexo';
            if ((materiaisDivulgacao.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`materiaisDivulgacao.${i}.arquivo`, materiaisDivulgacao.arquivo[0]);
        } else if (isEmpty(materiaisDivulgacao.nome)) {
            // Linha nova mas sem arquivo selecionado
            serie.materiaisDivulgacao.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = serie.recursosAcessibilidade?.length - 1; i >= 0; i--)
    {
        const recursosAcessibilidade = serie.recursosAcessibilidade[i];
        // anexo.tipo = 'anexo';
            if ((recursosAcessibilidade.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`recursosAcessibilidade.${i}.arquivo`, recursosAcessibilidade.arquivo[0]);
        } else if (isEmpty(recursosAcessibilidade.nome)) {
            // Linha nova mas sem arquivo selecionado
            serie.recursosAcessibilidade.splice(i, 1); // Remove o item do array
        }
    }

    for (let i = serie.anexosOutros?.length - 1; i >= 0; i--)
    {
        const anexosOutros = serie.anexosOutros[i];
        // anexo.tipo = 'anexo';
            if ((anexosOutros.arquivo as unknown as FileList)?.length > 0) {
            // Linha nova com arquivo selecionado
            form.append(`anexosOutros.${i}.arquivo`, anexosOutros.arquivo[0]);
        } else if (isEmpty(anexosOutros.nome)) {
            // Linha nova mas sem arquivo selecionado
            serie.anexosOutros.splice(i, 1); // Remove o item do array
        }
    }
};

export const prepararFormDataAnexo = (data: IFormStatePrograma | IFormStateEntidades, form: FormData) => {
    const anexos = (data as any).programaAnexos || (data as any).serieAnexos;
    const idField = (data as any).idPrograma ? 'idPrograma' : 'idSerie';
    const id = (data as any)[idField];

    const filteredAnexos = anexos?.filter(anexo => anexo.nome !== "invalid").map(anexo => {
        const anexoMetadata: any = {
            nome: anexo.nome,
            tipo: anexo.tipo
        };
        
        if (anexo.link) {
            anexoMetadata.bucket = anexo.gcs_bucket;
            anexoMetadata.path = anexo.gcs_path;
        }
        
        return anexoMetadata;
    });
    
    form.append(idField, JSON.stringify(id));
    form.append('anexos', JSON.stringify(filteredAnexos));

    filteredAnexos?.forEach((anexo, i) => {
        const originalAnexo = anexos[i];
        if (originalAnexo.arquivo && (originalAnexo.arquivo as unknown as FileList)?.length > 0) {
            form.append(`anexo.${i}.arquivo`, (originalAnexo.arquivo as unknown as FileList)[0]);
        }
    });
};